import React from "react";

export const plansData = [
  {
    id: "free",
    name: "Free Tier (Basic)",
    price: "Free",
    frequency: "",
    features: [
      "List up to 10 parts",
      "Basic profile",
      "Access to messenger (limited messages)",
      "Visible in search results (lower ranking)",
      "No analytics or promotional tools"
    ],
    iconName: "Star",
    color: "text-muted-foreground",
    buttonVariant: "outline",
    buttonTextDefault: "Get Started Free"
  },
  {
    id: "pro",
    name: "Pro Tier",
    price: "$79",
    frequency: "/month",
    features: [
      "List up to 500 parts",
      "Priority placement in AI search results",
      "Unlimited messaging",
      "Business profile with branding & contact info",
      "Access to buyer inquiries matching inventory",
      "Basic analytics (views, leads, CTRs)"
    ],
    iconName: "Zap",
    color: "text-primary",
    buttonVariant: "default",
    popular: true,
    buttonTextDefault: "Learn More",
    buttonTextMember: "Choose Plan"
  },
  {
    id: "premium",
    name: "Premium Tier",
    price: "$199",
    frequency: "/month",
    features: [
      "Unlimited parts listings",
      "Top placement & Featured Listings",
      "AI-powered inventory match alerts",
      "Receive Buyer Request Notifications",
      "Full analytics dashboard",
      "API or bulk upload access",
      "Dedicated customer support",
      "Promotion opportunities"
    ],
    iconName: "Building",
    color: "text-purple-600",
    buttonVariant: "secondary",
    buttonTextDefault: "Learn More",
    buttonTextMember: "Choose Plan"
  }
];

export const getPlanFrontendProperties = (planId) => {
  const mappings = {
    free: {
      iconName: "Star",
      color: "text-muted-foreground",
      buttonVariant: "outline",
      buttonTextDefault: "Get Started Free",
      buttonTextMember: "Get Started Free"
    },
    pro: {
      iconName: "Zap",
      color: "text-primary",
      buttonVariant: "default",
      buttonTextDefault: "Learn More",
      buttonTextMember: "Choose Plan"
    },
    premium: {
      iconName: "Building",
      color: "text-purple-600",
      buttonVariant: "outline",
      buttonTextDefault: "Learn More",
      buttonTextMember: "Choose Plan"
    }
  };

  return mappings[planId] || {};
};

export const getAddOnFrontendProperties = (addOnId) => {
  const mappings = {
    "featured-listings": {
      iconName: "Star",
      color: "text-yellow-500"
    },
    "pay-per-lead": {
      iconName: "Zap",
      color: "text-orange-500"
    },
    "buyer-requests": {
      iconName: "BellRing",
      color: "text-blue-500"
    },
    "sms-alerts": {
      iconName: "PlusCircle",
      color: "text-green-500"
    }
  };

  return (
    mappings[addOnId] || { iconName: "PlusCircle", color: "text-gray-500" }
  );
};

export const formatAddOnPrice = (addOn) => {
  if (addOn.price === 0) return "Free";

  if (addOn.frequency === "monthly") {
    return `$${addOn.price} / month`;
  }

  return `$${addOn.price}`;
};

export const pageVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1 }
  }
};

export const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { type: "spring", stiffness: 100 }
  }
};
